//auth api
export const LOGIN = 'login'
export const UPDATEPASSWORD = 'create-password'
export const RESETAUTHPASSWORD = 'reset-password'
export const CHECKEMAILEXIST = 'forgot-password'
export const SCHOOLLIST = 'school/list'
export const SCHOOLONE = 'school'
export const ORGANIZATIONONE = 'organisation'
export const ROLELIST = 'roles'
export const ADDUSER = 'school-user'
export const ORGANIZATIONLIST = 'organisation/list'
export const ATTENDANCEGARPH = 'graph-report-data' // chart of attandence
export const DOWNLOADUSERFILE = 'uploader'
//filters
export const TESTCODE = 'getTestCode'
